import React from "react";
import PropTypes from 'prop-types';
import {defaultOptions} from '../../../utils/utils';


export default class PluginConfiguration extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        enableSave: PropTypes.func.isRequired,
        disableSave: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        let defaultConfiguration = {};

        let configuration = defaultOptions(defaultConfiguration, props.configuration);

        this.state = Object.assign({}, configuration);
    }

    getConfiguration() {
        return {};
    }

    componentDidMount() {
        this.props.enableSave();
    }

    render() {
        return(
            <div className="emailPluginConfiguration" />
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/PluginConfiguration.js